export default __webpack_public_path__ + "static/media/Claudia-Queliconi.f988ba63.png";